import { runInAction } from 'mobx';

export const promiseWithObservableState = <TPromise>(
  promise: TPromise,
  setState: (isLoading: boolean) => void,
): TPromise => {
  runInAction(() => {
    setState(true);
  });

  const resolvedPromise = Promise.resolve(promise as unknown as Promise<any>);
  return resolvedPromise
    .finally(() => {
      runInAction(() => {
        setState(false);
      });
    }) as unknown as TPromise;
};